
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dokumen",
      function () {
        return require("private-next-pages/dokumen/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dokumen"])
      });
    }
  